<div class="callback-container">
  <div class="callback-content">
    <div class="logo-mark">
      <img src="/logo-monitori-icon.png" alt="Monitori" />
    </div>
    <h2>Autenticando</h2>
    <p>Validando seu acesso ao MonitoriCore</p>
    <div class="dots" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</div>
